import type { NotificationProps } from '../notification'

import Parser from 'html-react-parser'
import { useNavigate } from 'react-router-dom'

import { Notification } from '../notification'

export interface CarePlanNotificationProps extends NotificationProps {
  id: string
  clientName: string
  message: string
  assignedAt: string
  assignerName: {
    given?: string[]
    family?: string[]
    suffix?: string[]
  }
  patientId: string
  kind?: string
  place?: string
  isNew?: boolean
  urgent?: boolean
}

export function CarePlanNotification ({
  clientName,
  message,
  assignedAt,
  assignerName,
  patientId,
  kind,
  isNew,
  urgent,
  ...rest
}: CarePlanNotificationProps): JSX.Element {
  let navigate = useNavigate()

  let n = ''

  if (assignerName) {
    let first = assignerName?.given?.[0] ?? ''
    let last = assignerName?.family?.[0] ?? ''
    let suffixes = assignerName.suffix?.join(', ') ?? ''
    n = `${first} ${last} ${suffixes}`
  }

  let description = Parser(message || '')

  return (
    <Notification
      title='Care Plan'
      date={new Date(assignedAt)}
      onClick={() => {
        navigate(`/patient/${clientName}/${patientId}/patientFolder`)
        rest.onDismiss()
      }}
      {...rest}
    >
      <p className='font-inter'>
        {description}
      </p>

      {n && (
        <p className='font-inter'>
          Assigned by {n}
        </p>
      )}
    </Notification>
  )
}
